import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  static targets = ['source', 'trigger', 'icon'];
  static values = { sourceSelector: String };

  initialize() {
    this.copy = this.copy.bind(this);
  }

  triggerTargetConnected(trigger) {
    trigger.addEventListener('click', this.copy);
  }

  triggerTargetDisconnected(trigger) {
    trigger.removeEventListener('click', this.copy);
  }

  disconnect() {
    clearTimeout(this._resetTimer);
    this._tooltip?.dispose();
    this._tooltip = null;
    if (this.hasIconTarget) this.iconTarget.classList.replace('fa-check', 'fa-clipboard');
  }

  async copy(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const source = this.hasSourceTarget
      ? this.sourceTarget
      : this.hasSourceSelectorValue && document.querySelector(this.sourceSelectorValue);
    if (!source) return;

    const text = (source.matches('input, textarea, select') ? source.value : source.textContent).trim();

    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const field = document.createElement('textarea');
      field.value = text;
      field.style.position = 'fixed';
      field.style.opacity = '0';
      const focused = document.activeElement;
      document.body.append(field);
      field.select();
      try {
        if (!document.execCommand('copy')) return;
      } finally {
        field.remove();
        focused?.focus();
      }
    }

    this._showCopied(trigger);
  }

  _showCopied(trigger) {
    if (!this.element.isConnected) return;
    if (this.hasIconTarget) this.iconTarget.classList.replace('fa-clipboard', 'fa-check');
    this._tooltip?.dispose();
    this._tooltip = new Tooltip(trigger, { trigger: 'manual', title: 'Copied!' });
    this._tooltip.show();

    clearTimeout(this._resetTimer);
    this._resetTimer = setTimeout(() => {
      this._tooltip?.hide();
      if (this.hasIconTarget) this.iconTarget.classList.replace('fa-check', 'fa-clipboard');
    }, 2000);
  }
}
